import React from 'react';
import OfficePricing from './OfficePricing.react';
import OfficeVarietyBox from './OfficeVarietyBox.react';
import OfficeCustom from './OfficeCustom.react';

const OfficeOfferings = (props) => {
  return (
    <div className="office-offerings">
      <div className="office-offering">
        <OfficeVarietyBox />
      </div>
      <div className="office-offering">
        <OfficePricing />
      </div>
      <div className="office-offering">
        <OfficeCustom />
      </div>
    </div>
  );
};

export default OfficeOfferings;
